import * as React from "react";
import { cn } from "@/components/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  snaplandId?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", error, disabled, readOnly, snaplandId, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[hsl(var(--color-muted-foreground))] focus-visible:outline-none focus-visible:ring-2 rtl:text-right rtl:[direction:rtl]",
          "border-[hsl(var(--color-input))] focus-visible:ring-[hsl(var(--color-ring))]",
          error &&
            "border-[hsl(var(--color-destructive))] aria-[invalid=true]:ring-[hsl(var(--color-destructive))]",
          className
        )}
        aria-invalid={Boolean(error) || undefined}
        disabled={disabled}
        readOnly={readOnly}
        ref={ref}
        data-snapland-id={snaplandId || "input"}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };

